const state = {
    quizStarted: false,
    numQuestions: 0,
    numQuestionsAnswered: 0,  
    
    videosWatched: {},
    slug: null,
    selectedOptions:{}, //questionID,answerID Key-value pair

    quizFinished: false,
    
    quizPassed: false,
    wrongAnswersCount: 0,
    incorrectAllowed: 0,
    returnUrl: ''
}

export default state
